function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { EntityTypes } from '@guryou/core';
import { printTime } from '@guryou/utils';
import { FlexColumn, FlexRow, SmallText } from '../content';
import { HolidayOffIcon, PauseOffIcon } from '../icons';
import { getColorProps, getCustomerIcon, getEventIcon, getNamePreset } from './utils';
const checkEventSize = event => {
  const milliseconds = +new Date(event.endTime) - +new Date(event.startTime);
  const minutes = milliseconds / 60000;
  if (minutes <= 50) {
    return false;
  }
  return true;
};
const EventField = ({
  event,
  namePreset,
  t
}) => {
  const colorProps = getColorProps(event);
  const textColorProps = {
    ...colorProps,
    background: 'transparent'
  };
  const size = checkEventSize(event);
  if (event.entityType === 'pause' || event.entityType === 'holiday') {
    return /*#__PURE__*/React.createElement(FlexColumn, _extends({}, colorProps, {
      margin: 0,
      padding: 1,
      height: "100%",
      justifyContent: "start",
      alignItems: "start"
    }), event?.resources?.map(resource => /*#__PURE__*/React.createElement("span", {
      key: resource.id,
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }
    }, resource.name, event.entityType === 'pause' ? /*#__PURE__*/React.createElement(PauseOffIcon, {
      fontSize: "inherit"
    }) : /*#__PURE__*/React.createElement(HolidayOffIcon, {
      fontSize: "inherit"
    }))));
  }
  const content = /*#__PURE__*/React.createElement(FlexColumn, _extends({}, colorProps, {
    margin: 0,
    padding: 1,
    height: "100%",
    justifyContent: "start",
    alignItems: "start"
  }), /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "space-between",
    alignItems: "start",
    margin: 0
  }, event.entityType === EntityTypes.service && /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "start"
  }), getCustomerIcon(event.user, 'inherit'), " ", `${getNamePreset(namePreset, event)}`.toUpperCase()), event.entityType !== EntityTypes.service && /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), `${t('GENERAL.capacity')}`, ": ", event.capacity ?? 0, "/", event.totalCapacity)), !size && /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "flex-start",
    alignItems: "start",
    margin: 0
  }, /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('GENERAL.from'), ": ", printTime(event.startTime), " ", `${t('GENERAL.to')}: ${printTime(event.endTime)}`), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "center"
  }), event.serviceName, " / ", event.name, " ", getEventIcon(event, 'inherit')), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('PROFILE.resource'), ": ", event?.resources?.[0]?.name)), size && /*#__PURE__*/React.createElement(FlexRow, {
    justifyConten: "flex-start",
    alignItems: "start",
    margin: 0
  }, /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('GENERAL.from'), ": ", printTime(event.startTime), " ", `${t('GENERAL.to')}: ${printTime(event.endTime)}`), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12,
    display: "flex",
    alignItems: "center"
  }), event.serviceName, " / ", event.name, " ", getEventIcon(event, 'inherit')), /*#__PURE__*/React.createElement(SmallText, _extends({}, textColorProps, {
    xs: 12
  }), t('PROFILE.resource'), ": ", event?.resources?.[0]?.name)));
  return content;
};
export default EventField;